'use client'

import type { Page } from '@/payload-types'

import { Container, Heading } from '@/components'
import { Media } from '@/components/Media'
import RichText from '@/components/RichText'

import FingerprintImage from '@/public/assets/fingerprint-background.svg'

import { Breadcrumbs } from '@/components/ui/organisms/Breadcrumbs'
import { cn } from '@/utilities/cn'
import NextImage from 'next/image'
import type { FC } from 'react'

type MonsterHeroProps = Page['hero'] & {
  breadcrumbs?: Array<{
    label: string
    url: string
  }>
}

export const MonsterHero: FC<MonsterHeroProps> = ({
  heading,
  contentBlockRichText,
  media,
  headingExtraRow,
  useDefaultBottomMargin,
  breadcrumbs,
}) => {
  return (
    <div
      className={cn('gpf-monster-hero', {
        'gpf-monster-hero--default-margin': useDefaultBottomMargin,
      })}
    >
      {breadcrumbs && (
        <Breadcrumbs variant="light" absolute={true} items={breadcrumbs} />
      )}
      <Container
        variant="extra-small"
        className="gpf-monster-hero__wrapper"
        alignToRight={true}
      >
        <div className="gpf-monster-hero__title">
          {heading && <Heading color="green-2" as="h1" text={heading} size="2xl" />}
          {headingExtraRow && (
            <Heading color="green-2" as="h2" text={headingExtraRow} size="2xl" />
          )}
        </div>
        <div className="gpf-monster-hero__content">
          {contentBlockRichText && (
            <RichText data={contentBlockRichText} enableGutter={false} />
          )}
        </div>
        {media && typeof media === 'object' && (
          <div className="gpf-monster-hero__image-wrapper">
            <Media
              fill={true}
              priority={true}
              resource={{ ...media, width: 400, height: 560 }}
            />
          </div>
        )}
      </Container>
      <NextImage
        src={FingerprintImage}
        alt="fingerprint"
        className="gpf-monster-hero__background-object"
        width={200}
        height={200}
      />
    </div>
  )
}
